export default [    //单位
  {
    path: "/orgList",  //单位列表
    name: 'orgList',
    component: () => import("@/views/org/orgList.vue")
  },
  {
    path: "/orgDetail",  //单位详情
    name: 'orgDetail',
    component: () => import("@/views/org/orgDetail.vue")
  },
  {
    path: "/orgChoice",  //选择单位
    name: 'orgChoice',
    component: () => import("@/views/org/orgChoice.vue")
  },
  {
    path: "/orgAdd",  //创建单位
    name: 'orgAdd',
    component: () => import("@/views/org/orgAdd.vue")
  },
  {
    path: "/upregion",  //创建单位
    name: 'upregion',
    component: () => import("@/views/org/upregion.vue")
  }
]
